// extracted by mini-css-extract-plugin
export var blankBannerContainer = "BlankBanner-module--blankBannerContainer--d3341";
export var textLogo = "BlankBanner-module--textLogo--046b3";